const TRUSTPILOT_SCRIPT_ID = 'trustpilot-widget-bootstrap';
const TRUSTPILOT_SCRIPT_SRC = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: Element) => void;
    };
  }
}

let trustpilotReadyPromise: Promise<void> | null = null;

function ensureTrustpilotScript(): Promise<void> {

  if (trustpilotReadyPromise) {

    return trustpilotReadyPromise;
  
  }

  trustpilotReadyPromise = new Promise<void>((resolve, reject) => {

    if (typeof window === 'undefined') {

      resolve();

      return;
    
    }

    if (window.Trustpilot?.loadFromElement) {

      resolve();

      return;
    
    }

    const existing = document.getElementById(TRUSTPILOT_SCRIPT_ID) as HTMLScriptElement | null;

    if (existing) {

      // Script tag exists; wait for it to finish loading.
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error('Trustpilot script failed to load')), { once: true });

      return;
    
    }

    const script = document.createElement('script');
    script.id = TRUSTPILOT_SCRIPT_ID;
    script.src = TRUSTPILOT_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Trustpilot script failed to load'));

    document.head.appendChild(script);
  
  });

  return trustpilotReadyPromise;

}

export default defineNuxtPlugin(() => {

  const trustpilotReady = ensureTrustpilotScript().catch(() => {
    // Swallow to avoid crashing the app on 3rd-party failure.
  });

  return {
    provide: {
      trustpilotReady,
    },
  };

});
